import React from "react";
import "./toast.css";

interface Props {
    show: boolean;
    title: string;
    message: string;
    actionLabel: string;
    onAction: () => void;
}

export function Toast({ show, title, message, actionLabel, onAction }: Props) {
    return (
        <div className={`toast${show ? " show" : ""}`} role="status" aria-live="polite" aria-atomic="true">
            <div className="toast__content"><strong>{title}</strong><small>{message}</small></div>
            <button className="toast__action" type="button" onClick={onAction}>{actionLabel}</button>
        </div>
    );
}
